<template>
  <div class="postcode-lookup-component">
    <div class="row">
      <div class="col-12" :class="{ 'col-md-6': !hideManualEntry }">
        <div class="d-flex">
          <div class="form-group form-label-group flex-1">
            <input
              v-model="postcode"
              id="postcode"
              type="text"
              class="postcode-input form-control"
              :class="{
                                'is-invalid': error,
                                'text-uppercase': true
                            }"
              name="postcode"
              required
              autocomplete="postcode"
              autofocus
              placeholder="Postcode"
              @change="lookupPostcode(false)"
            />
            <label for="postcode">Postcode</label>

            <span
              v-if="error !== null"
              class="invalid-feedback"
              role="alert"
            >
              <strong>{{ error }}</strong>
            </span>
          </div>

          <button
            type="button"
            class="btn btn-cg btn-rounded-right mb-3 d-flex align-items-center justify-content-between"
            @click="lookupPostcode(!hideManualEntry)"
            :disabled="loading"
          >
            {{ buttonLabel ?? 'Find Address' }}
            <i class="far fa-map-marker ms-4"></i>
          </button>
        </div>
      </div>

      <div v-if="!hideManualEntry" class="col-12 col-md-6">
        <div class="d-flex align-items-center h-100 pb-3">
          <p class="mb-0">
            Or
            <span
              @click="toggleManualEntry"
              class="text-underline cursor-pointer"
            >type in address manually?</span>
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-9">
        <div v-if="loading" class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>

        <ul class="list-group list-group-flush">
          <li
            class="list-group-item cursor-pointer"
            v-for="address in addresses"
            :key="address.Id"
            @click="selectedAddress = address; addressSelected();"
          >
            <span v-if="address.Label">
              {{ address.Label.replace("\n", ", ") }}</span>
            <span v-else>
              {{ address.Text }} - {{ address.Description }}</span>
          </li>
        </ul>
      </div>
    </div>

    <input v-model="lat" type="hidden" name="lat" id="lat"/>
    <input v-model="lng" type="hidden" name="lng" id="lng"/>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      postcode: null,
      container: null,
      error: null,
      manualEntry: false,
      loading: false,
      addresses: [],
      selectedAddress: null,
      finalAddress: null,
      lat: null,
      lng: null
    };
  },

  props: {
    preloadPostcode: {
      type: String,
      default: null,
    },
    hideManualEntry: {
      type: Boolean,
      default: false,
    },
    buttonLabel: {
      type: String,
      default: 'Find Address',
    }
  },

  created() {
    this.postcode = this.preloadPostcode;
    console.log(this.hideManualEntry);
  },

  methods: {
    isValidUKPostcode(postcode) {
      const regex = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]? ?[0-9][A-Z]{2}$/i;
      return regex.test(postcode);
    },

    lookupPostcode(showAddresses = true) {
      this.error = null;

      // Ensure a postcode has been entered.
      if (!this.postcode || this.isValidUKPostcode(this.postcode) === false) {
        this.error = "Please enter a valid UK postcode.";
        return;
      }

      // No loading circle if we're not showing addresses. This is used when getting the lat/lng without showing the addresses.
      if (showAddresses) {
        this.loading = true;
      }

      this.addresses = [];
      this.selectedAddress = null;
      this.finalAddress = null;

      return axios
        .post("/api/v1/loqate/postcode_lookup", {
          postcode: this.postcode,
          container: this.container
        })
        .then(response => {
          this.loading = false;
          this.selectedAddress = null;

          if (showAddresses) {
            this.addresses = response.data.addresses;
          }

          if (response.data.geoData) {
            this.setGeoFields(response.data.geoData[0]);
          }

          // this.$nextTick(() => {
          //     this.$refs.selectAddress.focus();
          // });
        })
        .catch(error => {
          this.loading = false;
          this.selectedAddress = null;
          this.error = error.response.data.message;
        });
    },

    postcodeSelected() {
      //
    },

    setGeoFields(geoData) {
      this.lat = geoData.Latitude;
      this.lng = geoData.Longitude;


      Livewire.emit('handleGeoData', {
        lat: this.lat,
        lng: this.lng,
        postcode: this.postcode
      });
    },

    addressSelected() {
      console.log(this.selectedAddress);
      this.addresses = [];

      // Is it an address or a postcode?
      if (this.selectedAddress.Type === "Address") {
        this.getAddress();
      } else if (this.selectedAddress.Type === "Postcode") {
        this.container = this.selectedAddress.Id;
        this.lookupPostcode();
      } else {
        // Assume it's the end address.
        this.finalAddress = this.selectedAddress;

        // Emit the event to Vue and JS.
        this.$emit("address-selected", this.finalAddress);

        // Ensure the wrapper is visible.
        $('[data-loqate="wrapper"]').removeClass('d-none');


        // Attempt to fill any fields with the "loqate" data attribute.
        let fieldsData = {};
        for (const field in this.finalAddress) {
          if (this.finalAddress.hasOwnProperty(field)) {
            if (field === "PostalCode") {
              this.postcode = this.finalAddress[field];
            } else {
              const element = document.querySelector(
                `[data-loqate="${field}"]`
              );
              if (element) {
                element.value = this.finalAddress[field];
                fieldsData[field] = this.finalAddress[field];
              }
            }
          }
        }

        Livewire.emit('emitAddressData', fieldsData);
      }

      this.selectedAddress = null;
    },

    getAddress() {
      this.loading = true;
      this.container = null;

      return axios
        .post("/api/v1/loqate/address_lookup", {
          address_id: this.selectedAddress.Id
        })
        .then(response => {
          this.loading = false;
          this.selectedAddress = null;
          this.addresses = response.data.addresses;

          const uniqueIds = [];

          // Filter out addresses with duplicate 'ID's.
          this.addresses = this.addresses.filter(address => {
            if (uniqueIds.includes(address.Id)) {
              return false;
            }

            uniqueIds.push(address.Id);

            return true;
          });

          // Only 1 result? Select that address automatically.
          if (this.addresses.length === 1) {
            this.selectedAddress = this.addresses[0];
            this.addressSelected();
          } else {
            // this.$nextTick(() => {
            //     this.$refs.selectAddress.focus();
            // });
          }
        })
        .catch(error => {
          this.loading = false;
          this.selectedAddress = null;
          this.error = error.response.data.message;
        });
    },

    toggleManualEntry() {
      this.manualEntry = !this.manualEntry;

      // Ensure the wrapper is visible.
      $('[data-loqate="wrapper"]').toggleClass('d-none');
    }
  }
};
</script>

<style lang="scss" scoped>
.postcode-lookup-component {
  .postcode-input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border: 1px solid white;
  }

  .list-group {
    border-radius: 10px;
    max-height: 400px;
    overflow-y: scroll;
  }
}
</style>
